
import { Vue, Component, Ref } from 'vue-property-decorator';
import { AccountService } from '@/services/account_service';
import lazyInject from '@/di';
import { handleTree } from '@/common/utils';
import { ActivitySignup } from '@/models/activity.model';
import { EDYHUserStatus, EDYHUserType } from '@/common/enum/account';
import { AgencyOperationService } from '@/services/agency_operation.service';
import AgencyTypeModal from './AgencyTypeModal.vue';


@Component({
  components: {
    AgencyTypeModal,
  },
})
export default class AgencyUserModal extends Vue {
  visible = false;

  inputValue = '';

  @lazyInject(AccountService)
  protected accountService!: AccountService;

  @Ref()
  agencyTypeModal!: AgencyTypeModal;


  @lazyInject(AgencyOperationService)
  agencyOperationService!: AgencyOperationService;

  radioValue = 1;

  selectedRowKeys: any[] = [];

  treeDataOld: any[] = [];

  treeData: any[] = [];

  treeDataUser: any[] = [];

  filterForm: any = {
    deptId: '',
  };


  EDYHUserType = EDYHUserType;

  EDYHUserStatus = EDYHUserStatus;


  userTypeList: EDYHUserType[] = [
    EDYHUserType.全部,
    EDYHUserType.管理员,
    EDYHUserType.审核员,
    EDYHUserType.地推员,
    EDYHUserType.店铺老板,
    EDYHUserType.雷达安装工,
  ];

  userList: any[] = [];

  pagination: any = {
    deptId: '',
    total: 0,
    current: 1,
    pageSize: 10,
    onChange: this.paginationChange,
  };

  handleChange(value: any) {
    console.log(value);
    this.radioValue = value.target.value;
  }

  onSelectChange(selectedRowKeys: any, selectedRows: any) {
    console.log(selectedRowKeys, selectedRows);
    this.selectedRowKeys = selectedRowKeys;
  }

  init() {
    this.visible = true;
    this.sysDeptList({});
    const params = {
      pageSize: 10,
      page: 1,
    };
    this.pagination = {
      total: 0,
      current: 1,
      pageSize: 10,
    };
    this.list(params);
  }

  onChange() {
    const value = this.inputValue;
    if (value === '') {
      this.treeData = [];
      this.$nextTick(() => {
        this.treeData = handleTree(this.treeDataOld, 'id', 'parentId', 'children');
      });
      return;
    }
    const Arrt: any[] = [];
    this.treeDataOld.forEach((item: any) => {
      if (item.deptName.indexOf(value) > -1) {
        const parentId = item.ancestors.split(',');
        const parentIdArr = this.funPanduan(parentId);
        Arrt.push(...parentIdArr);
        Arrt.push(item);
      }
    });
    const map = new Map();
    const newArr = Arrt.filter((v) => !map.has(v.id) && map.set(v.id, v));
    this.treeData = handleTree(newArr, 'id', 'parentId', 'children');
  }

  funPanduan(arr: any) {
    const parentId: any[] = [];
    arr.forEach((item: any) => {
      this.treeDataOld.forEach((res: any) => {
        if (res.id === Number(item)) {
          parentId.push(res);
        }
      });
    });
    return parentId;
  }

  dragend(event: any) {
    this.pagination.deptId = event[0];
    const params = {
      pageSize: 10,
      page: 1,
      deptId: this.pagination.deptId,
    };
    this.pagination = {
      total: 0,
      current: 1,
      pageSize: 10,
    };
    this.list(params);
  }

  async sysDeptList(params: any) {
    const res = await this.accountService.sysDeptList(params) as any;
    if (res) {
      const activitySignup = res.map((item: any) => ActivitySignup.from(item)) as any;
      const tree = handleTree(activitySignup, 'id', 'parentId', 'children');
      this.treeDataOld = activitySignup;
      this.treeData = tree;
      this.treeDataUser = tree;
    }
  }

  async list(params: {
    pageSize?: number;
    page: number;
    phone?: string;
    aid?: number;
    id?: number;
    userType?: number;
    userName?: string;
  }) {
    const res = await this.accountService.list(params);

    if (res) {
      this.userList = res.list;
      this.pagination = {
        total: res.total,
        current: res.page,
        deptId: this.pagination.deptId,
        pageSize: Number(res.pageSize),
        onChange: this.paginationChange,
      };
    }
  }

  paginationChange(page: number, pageSize: number) {
    this.pagination.page = page;
    this.pagination.pageSize = pageSize;
    const params = {
      page: this.pagination.page,
      pageSize: this.pagination.pageSize,
      deptId: this.pagination.deptId,
    };
    console.log(params);
    this.list(params);
  }

  cancel() {
    this.visible = false;
    this.selectedRowKeys = [];
  }

  confirm() {
    // this.visible = false;
    if (this.selectedRowKeys.length === 0) {
      this.$message.error('请选择用户');
      return;
    }
    const _ids = this.selectedRowKeys.join(',');
    this.agencyTypeModal.init(_ids);
    // this.$emit('confirm', this.radioValue);
  }
}
